import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "absolute inset-0 flex flex-col bg-gray-brand-100" }
const _hoisted_2 = { class: "customer-record__content" }

import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import ConversationsMenu from '@/components/customers/ConversationsMenu.vue'
import CustomerProfileHeader from '@/components/customers/CustomerProfileHeader.vue'
import CustomerTabBar from '@/components/customers/CustomerTabBar.vue'
import NewContactModal from '@/components/neue/NewContactModal.vue'
import NeueOrderModal from '@/components/NeueOrderModal.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import { useCustomerLifetimeStats } from '@/composables/useCustomerLifetimeStats'
import { provideCustomerRecord } from '@/composables/useCustomerRecord'
import { useEntitlements } from '@/composables/useEntitlements'
import { PHONE_MEDIA_QUERY, useMediaQuery } from '@/composables/useMediaQuery'
import { customerTabPath, visibleCustomerTabs } from '@/config/customerTabs'
import privilegeService from '@/services/privilege.service'


export default {
  __name: 'CustomerRecordLayout',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const can = (resource, action) => privilegeService.canAccessResourceAction(resource, null, action)
const { on } = useEntitlements()
const canReadProfile = computed(() => can('customer_profile', 'read'))
const canCreateOrders = computed(() => can('orders', 'create'))

const conversationUserPairId = computed(() => String(route.params.id))
const activeTab = computed(() => route.meta.customerTab ?? 'messages')
const activeView = computed(() => route.meta.customerView ?? activeTab.value)

const tabs = computed(() =>
  visibleCustomerTabs(can, on).map(tab => ({
    ...tab,
    to: customerTabPath(tab, { id: conversationUserPairId.value, listId: route.params.listid })
  }))
)

const isPhone = useMediaQuery(PHONE_MEDIA_QUERY)
const { state: lifetimeState, lifetime } = useCustomerLifetimeStats(() =>
  canReadProfile.value ? conversationUserPairId.value : null
)

const scrollArea = ref(null)
const newOrderOpen = ref(false)
const newContactOpen = ref(false)

const openNewOrder = () => {
  newOrderOpen.value = true
}

const selectTab = key => {
  if (key === activeView.value) return
  const tab = tabs.value.find(candidate => candidate.key === key)
  if (tab) router.push(tab.to)
}

watch(activeView, () => {
  if (scrollArea.value) scrollArea.value.scrollTop = 0
})

watch(conversationUserPairId, () => {
  newOrderOpen.value = false
})

provideCustomerRecord({ lifetimeState, lifetime })

return (_ctx, _cache) => {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(SecondaryNav, null, {
    sidebar: _withCtx(() => [
      _createVNode(ConversationsMenu, {
        onAddContact: _cache[0] || (_cache[0] = $event => (newContactOpen.value = true))
      })
    ]),
    main: _withCtx(() => [
      _createVNode(NewContactModal, {
        "is-open": newContactOpen.value,
        onCloseModal: _cache[1] || (_cache[1] = $event => (newContactOpen.value = false))
      }, null, 8, ["is-open"]),
      _createVNode(NeueOrderModal, {
        "is-open": newOrderOpen.value,
        pair: conversationUserPairId.value,
        onCloseModal: _cache[2] || (_cache[2] = $event => (newOrderOpen.value = false))
      }, null, 8, ["is-open", "pair"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CustomerProfileHeader, {
          "conversation-user-pair-id": conversationUserPairId.value,
          "active-tab": activeTab.value,
          tabs: tabs.value,
          "lifetime-state": _unref(lifetimeState),
          lifetime: _unref(lifetime),
          compact: _unref(isPhone),
          "can-create-orders": canCreateOrders.value,
          onNewOrder: openNewOrder
        }, null, 8, ["conversation-user-pair-id", "active-tab", "tabs", "lifetime-state", "lifetime", "compact", "can-create-orders"]),
        _createElementVNode("div", {
          ref_key: "scrollArea",
          ref: scrollArea,
          "data-test": "record-scroll",
          class: _normalizeClass(["customer-record__scroll", activeTab.value === 'messages' ? 'is-thread' : 'is-page'])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_view)
          ])
        ], 2),
        _createVNode(CustomerTabBar, {
          tabs: tabs.value,
          "active-tab": activeTab.value,
          onSelect: selectTab
        }, null, 8, ["tabs", "active-tab"])
      ])
    ]),
    _: 1
  }))
}
}

}